import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ToolbarItemAbstract} from '../toolbar-item-abstract.component';
import {GenericCrudService} from '../../../../../../services/generic-crud.service';
import {MessageGrowlService} from '../../../../../../../core/message/message-growl.service';
import {FormViewerComponent} from '../../../../../../form-viewer/form-viewer.component';
import {GenericTreeGridComponent} from '../../../../generic-tree-grid/generic-tree-grid.component';
import {ToolbarItemSavePrecalculationArticleService} from '../../../services/save/toolbar-item-save-precalculation-article.service';
import {EntityDirtyStoreService} from '../../../../../services/entity-dirty-store.service';
import {ExecutionStepPayload} from '../../../../../../../core/executor/execution-step-payload';
import {ComponentRefreshExecutionStep} from '../../../../../../services/execution-step/component-refresh-execution-step';
import {ExecutionStepFactoryService} from '../../../../../../../core/executor/factory/execution-step-factory.service';
import {ExecutionStatus} from '../../../../../../../core/executor/execution-status';
import {ExecutorActionEvent} from '../../../../../../../core/executor/service/executor-actions/executor-action-event';
import {ExecutorService} from '../../../../../../../core/executor/executor.service';
import {ComponentCloseDialogExecutionStep} from '../../../../../../services/execution-step/component-close-dialog-execution-step';
import {GenericTurboGridComponent} from '../../../../generic-turbo-grid/generic-turbo-grid.component';
import {ModulesStateService} from '../../../../../services/modules-state.service';
import {GenericElementAbstract} from '../../../../generic-element-abstract.component';
import {ElementType} from '../../../../../services/ElementContext';
import {TOAST_LIFE_INFINITE, ToastComponentsRegistry, ToastService} from '../../../../../../../core/service/toast.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-toolbar-item-add-pre-calculation-article',
    template: ''
})
export class ToolbarItemSavePreCalculationArticleComponent extends ToolbarItemAbstract {

  constructor(
    protected genericCrudService: GenericCrudService,
    protected messageGrowlService: MessageGrowlService,
    protected translateService: TranslateService,
    protected preCalculationArticleSaveService: ToolbarItemSavePrecalculationArticleService,
    protected entityDirtyStore: EntityDirtyStoreService,
    protected executionStepFactoryService: ExecutionStepFactoryService,
    protected executorService: ExecutorService,
    protected modulesStateService: ModulesStateService,
    protected toastService: ToastService,
  ) {
    super();
  }

  public click() {
    const component = this.getComponent();

    if (component instanceof FormViewerComponent) {
      for (const slaveContext of component.getElementContext().getSlaveElementContexts()) {
        const genericArticlesGrid = slaveContext.component;
        let otherArticlesGrid = null;

        for (const subSlaveContext of genericArticlesGrid.getElementContext().getSlaveElementContexts()) {
          if (subSlaveContext.component instanceof GenericTreeGridComponent) {
            otherArticlesGrid = subSlaveContext.component;
            break;
          }
        }

        if (genericArticlesGrid instanceof GenericTurboGridComponent && otherArticlesGrid instanceof GenericTreeGridComponent) {
          const entity = component.getSelectedEntity();
          const steps = [
            // this.executionStepFactoryService.create(ComponentCloseDialogExecutionStep, new ExecutionStepPayload(component)),
            this.executionStepFactoryService.create(ComponentRefreshExecutionStep, new ExecutionStepPayload(component))
          ];

          this.toastService.custom(ToastComponentsRegistry.PROGRESS_BAR, {
            severity: 'info',
            life: TOAST_LIFE_INFINITE,
            closable: false,
            summary: this.translateService.instant('COMMON.LOADING_PLEASE_WAIT')
          });

          this.genericCrudService.editEntity('phoenix/precalculations/' + entity.id, entity, {embedded: 'self'}).subscribe(
            (savedEntity) => {
              entity['isChanged'] = false;
              this.entityDirtyStore.remove(entity);
              this.preCalculationArticleSaveService.save(genericArticlesGrid, otherArticlesGrid).subscribe((result) => {
                this.executorService
                  .setSteps(steps)
                  .execute()
                  .subscribe((status: ExecutionStatus) => {
                    this.toastService.clear(ToastComponentsRegistry.PROGRESS_BAR);

                    if (!status.isSuccess()) {
                      this.messageGrowlService.error(this.translateService.instant('COMMON.ERROR'));
                    } else {
                      this.messageGrowlService.success(
                        this.translateService.instant('COMMON.DATA_SAVED'),
                        this.translateService.instant('COMMON.SUCCESS')
                      );
                      this.enableWizardButtons();
                      component.recheckToolbarItems();
                      component.executeAction(ExecutorActionEvent.ComponentSaved, component).subscribe();
                    }
                  });

              });
            }
          );
          break;
        }
      }
    }
  }

  enableWizardButtons(): void {
    const wizardComponent: any = this.modulesStateService.getCurrent().getAllComponents().find((aComponent: GenericElementAbstract) => {
      return aComponent.elementContext && aComponent.elementContext.type === ElementType.Wizard
    });

    if (wizardComponent && wizardComponent.wizardElement) {
      const wizardElement = wizardComponent.wizardElement;
      for (const wizardElementButton of wizardElement.buttons || []) {
        wizardElementButton.isDisabled = false;
      }
    }
  }
}
